import { fromJS } from 'immutable';

export const TSUNAMI_EVENT_SEARCH_TOGGLE_SECTION = 'TSUNAMI_EVENT_SEARCH_TOGGLE_SECTION';

const initialState = fromJS({
  sourceParametersExpanded: true,
  tsunamiRunupExpanded: true,
  tsunamiEffectsExpanded: true,
  sourceEffectsExpanded: true,
});

// default param first is the redux convention https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers
// eslint-disable-next-line default-param-last
export const tsunamiEventSearchPageReducer = (state = initialState, action) => {
  switch (action.type) {
    case TSUNAMI_EVENT_SEARCH_TOGGLE_SECTION:
      return state.set(action.section, !state.get(action.section));
    default:
      return state;
  }
};
